exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.games[data-v-a90b8de0] {\n  padding: 16px 12px;\n}\nsmall[data-v-a90b8de0] {\n  font-size: 0.7em;\n}\n.link[data-v-a90b8de0] {\n  color: #2a7ae2;\n  cursor: pointer;\n  text-decoration: none;\n  background-image: linear-gradient(transparent 0, #2a7ae2 1px, #2a7ae2 4px);\n  background-size: 4px 2px;\n  background-repeat: repeat-x;\n  background-position-y: 1.3125em;\n  margin: 8px 0;\n}\n.players[data-v-a90b8de0] {\n  overflow: hidden;\n}\n", ""]);

// exports
